import { Branding } from "../../branding/branding"
import { User } from "../../globalStates/LoggedInUser"
import {
    IconFacebookOriginal,
    IconInstagramOriginal,
    IconLinkedInOriginal,
    IconPinterestOrginal,
    IconTikTokOriginal,
    IconXOriginal,
    IconXingOriginal,
    IconYouTubeOriginal,
    VGIcon
} from "../../ui/Icons"
import { SocialMediaBaseLink, SocialMediaType } from "./MyProfilePageContentBranding"

interface SocialMediaItemType {
    labelText: string
    type: SocialMediaType
    value: string
    icon: VGIcon
}

export const getSocialMediaItemsConfig = (branding: Branding, user: User): SocialMediaItemType[] => {
    return [
        {
            labelText: branding.myProfilePageContent.facebookLinkLabel,
            type: SocialMediaType.FACEBOOK,
            value: user.facebook ?? "",
            icon: IconFacebookOriginal({
                width: "20",
                height: "20"
            })
        },
        {
            labelText: branding.myProfilePageContent.xLinkLabel,
            type: SocialMediaType.TWITTER,
            value: user.twitter ?? "",
            icon: IconXOriginal({
                width: "20",
                height: "20"
            })
        },
        {
            labelText: branding.myProfilePageContent.linkedInLinkLabel,
            type: SocialMediaType.LINKEDIN,
            value: user.linkedIn ?? "",
            icon: IconLinkedInOriginal({
                width: "20",
                height: "20"
            })
        },
        {
            labelText: branding.myProfilePageContent.xingLinkLabel,
            type: SocialMediaType.XING,
            value: user.xing ?? "",
            icon: IconXingOriginal({
                width: "20",
                height: "20"
            })
        },
        {
            labelText: branding.myProfilePageContent.instagramLinkLabel,
            type: SocialMediaType.INSTAGRAM,
            value: user.instagram ?? "",
            icon: IconInstagramOriginal({
                width: "20",
                height: "20"
            })
        },
        {
            labelText: branding.myProfilePageContent.youTubeLinkLabel,
            type: SocialMediaType.YOUTUBE,
            value: user.youTube ?? "",
            icon: IconYouTubeOriginal({
                width: "20",
                height: "20"
            })
        },
        {
            labelText: branding.myProfilePageContent.pinterestLinkLabel,
            type: SocialMediaType.PINTEREST,
            value: user.pinterest ?? "",
            icon: IconPinterestOrginal({
                width: "20",
                height: "20"
            })
        },
        {
            labelText: branding.myProfilePageContent.tiktokLinkLabel,
            type: SocialMediaType.TIKTOK,
            value: user.tiktok ?? "",
            icon: IconTikTokOriginal({
                width: "20",
                height: "20"
            })
        }
    ]
}

// method for repalcing youTube & linkedIn socialMediaKey for updateValue inside function getSocialMediaFields()
export const mapSocialMediaKey = (type: SocialMediaType) => {
    switch (type) {
        case SocialMediaType.YOUTUBE:
            return "youTube"
        case SocialMediaType.LINKEDIN:
            return "linkedIn"
        default:
            return type.toLowerCase()
    }
}

// method for repalcing twitter.com url link for x.com to automatically generate when typing in social media on Edit Profile page
export const mapSocialMediaBaseLink = (type: SocialMediaType) => {
    if (type === "TWITTER") return SocialMediaBaseLink[SocialMediaType.X]
    else return SocialMediaBaseLink[type]
}
